import { ReactNode } from 'react';
import * as styles from 'src/modals/common/Summary/Summary.css';

interface SummaryWrapperProps {
  children: ReactNode;
}
export const SummaryWrapper = ({ children }: SummaryWrapperProps) => {
  return <div className={styles.summaryWrapper}>{children}</div>;
};
